/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {
    ISymbolStateConfig,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {DirtyWildsSpineAnimationNames} from "../../config/DirtyWildsSpineAnimationNames";
import {DirtyWildsGameAssets} from "../DirtyWildsGameAssets";
import {DirtyWildsGameConfig} from "../DirtyWildsGameConfig";
import {DirtyWildGameMode} from "../features/DirtyWildsRespinZeroBetController";
import {DirtyWildsReelController} from "../reel/DirtyWildsReelController";
import {DirtyWildsModeData} from "../server/data/DirtyWildsModeData";


export enum DirtyWildsSymbols {

    NONE = "none",
    L1 = "L1",
    L2 = "L2",
    L3 = "L3",
    L4 = "L4",
    L5 = "L5",

    M1 = "M1",
    M2 = "M2",
    M3 = "M3",
    M4 = "M4",
    M5 = "M5",

    W = "W",
    W_STICKY = "WSticky",
    S = "S"

}


export class DirtyWildsStateReelSymbol extends StateReelSymbol {


    get winSpine():PIXI.spine.Spine {
        if(!this._winSpine) {
            this._winSpine = this.createWinSpine(this.symName);
        }
        return this._winSpine;
    }

    set winSpine(value:PIXI.spine.Spine) {
        this._winSpine = value;
    }

    get controller():DirtyWildsReelController {
        return this._controller;
    }

    set controller(value:DirtyWildsReelController) {
        this._controller = value;
    }

    get speedUpCoolDown():boolean {
        return this._speedUpCoolDown;
    }

    set speedUpCoolDown(value:boolean) {
        this._speedUpCoolDown = value;
    }

    get speedUpWinAnim():boolean {
        return this._speedUpWinAnim;
    }

    set speedUpWinAnim(value:boolean) {
        this._speedUpWinAnim = value;
    }

    protected _controller:DirtyWildsReelController;
    private _genericWinContainer:PIXI.Container;
    private _winSpine:PIXI.spine.Spine;
    //private _initialWinTl:TimelineLite;
    private _individualWinTl:TimelineLite;
    private _speedUpCoolDown:boolean;
    private _speedUpWinAnim:boolean;


    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    protected initAnimations():void {
        this._genericWinContainer = new PIXI.Container();
        this._genericWinContainer.visible = false;
    }

    public static isLowWin(symbol:string):boolean {
        return symbol == "L1" || symbol == "L2";
    }

    public static isSuperLowWin(symbol:string):boolean {
        return symbol == "L3" || symbol == "L4" || symbol == "L5";
    }

    public replaceWithNewSymbolInReel(newName:string, deleteOld:boolean, state?:ISymbolStateConfig):void {
        this._controller.replaceWithNewSymbol(this, newName, deleteOld, state);
    }

    public deleteSelf() {
        this._controller.removeTheOldSymbol(this);

    }

    public liftOutOfReels() {
        this._controller.liftSymbolOutOfReel(this);
    }

    public replaceWithSymbol(newSymbol:StateReelSymbol) {
        this._controller.replaceSymbolWithSymbol(this, newSymbol)
    }

    private createWinSpine(symName:string):PIXI.spine.Spine {
        const spine = new PIXI.spine.Spine(GameResources.getSpineAsset(DirtyWildsGameAssets.GENERIC_SYMBOL_WIN_SPINE));

        if(DirtyWildsStateReelSymbol.isLowWin(symName)) {
            spine.skeleton.setSkinByName("lowWin");
        } else if(DirtyWildsStateReelSymbol.isSuperLowWin(symName)) {
            spine.skeleton.setSkinByName("superLowWin");
        } else {
            spine.skeleton.setSkinByName("midWin");
        }
        this._genericWinContainer.addChild(spine);
        return spine;
    }

    protected getInitialWinAnim():TimelineLite {
        let animName:string = DirtyWildsSpineAnimationNames.GENERIC_SYMBOL_WIN_SPINE_INDIVIDUAL_WIN_MID;
        if(DirtyWildsStateReelSymbol.isLowWin(this.symName) || DirtyWildsStateReelSymbol.isSuperLowWin(this.symName)) {
            animName = DirtyWildsSpineAnimationNames.GENERIC_SYMBOL_WIN_SPINE_INDIVIDUAL_WIN;
        }
        const tl = new TimelineLite();
        tl.add(new SpineTween(this.winSpine, 0, null));
        tl.add(() => this.winSpine.state.timeScale = this.speedUpWinAnim ? 2 : 1);
        tl.add(new SpineTween(this.winSpine, 0, animName));
        tl.add(() => {
            this.speedUpWinAnim = false;
            this.winSpine.state.timeScale = 1;
        });
        this.addChild(this._genericWinContainer);
        return tl;
    }

    protected getIndividualWin():TimelineLite {
        let animName:string = DirtyWildsSpineAnimationNames.GENERIC_SYMBOL_WIN_SPINE_INDIVIDUAL_WIN_MID;
        if(DirtyWildsStateReelSymbol.isLowWin(this.symName) || DirtyWildsStateReelSymbol.isSuperLowWin(this.symName)) {
            animName = DirtyWildsSpineAnimationNames.GENERIC_SYMBOL_WIN_SPINE_INDIVIDUAL_WIN;
        }
        const tl = new TimelineLite();
        tl.add(new SpineTween(this.winSpine, 0, null));
        tl.add(new SpineTween(this.winSpine, 0, animName));
        this.addChild(this._genericWinContainer);
        return tl;
    }

    protected getStateTl(state:string, stateAnimation:TimelineSprite):TimelineLite {
        const stateTl:TimelineLite = new TimelineLite();

        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.win.keyword) {
            stateTl.add(() => this._controller.moveSymbolToTopLayer(this));
            stateTl.add(this.getInitialWinAnim());
        }

        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.individualWin.keyword) {
            stateTl.add(() => this._controller.moveSymbolToTopLayer(this));
            stateTl.add(this.getIndividualWin(), 0);
            // Removed by @sam, [] |skip tilting/ shake effect| issue #84 https://github.com/nolimitcity/mayanmagic/issues/84
            /*
            let a:TimelineLite = new TimelineLite();
            a.add(new TweenLite(this, 0.13, {rotation: 0}));
            a.add(new TweenLite(this, 0.033, {rotation: 0.05}));
            a.add(new TweenLite(this, 0.09, {rotation: -0.05}));
            a.add(new TweenLite(this, 0.09, {rotation: 0.03}));
            a.add(new TweenLite(this, 0.12, {rotation: 0}));
            let b:TimelineLite = new TimelineLite();
            b.add(new TweenLite(this.scale, 0.13, {x: 1, y: 1}));
            b.add(new TweenLite(this.scale, 0.03, {x: 1.1, y: 1.1}));
            b.add(new TweenLite(this.scale, 0.12, {x: 1, y: 1}));
            stateTl.add(a, 0);
            stateTl.add(b, 0);
            */
        }

        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.spin.keyword) {
            if((DirtyWildsModeData.instance.mode == DirtyWildGameMode.STICKY_RESPIN || DirtyWildsModeData.instance.isRandomFeatureTriggered) && this.symName != DirtyWildsSymbols.W) {
                stateTl.add(() => stateAnimation.alpha = 0.8);
            } else {
                stateTl.add(() => stateAnimation.alpha = 1.0);
            }
        }

        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.noWin.keyword) {
            stateTl.add(() => this._controller.moveSymbolToNoWinLayer(this));
        }

        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.dim.keyword) {
            stateTl.add(new TweenLite(stateAnimation, 0.5, {alpha : 0.4}));
        }

        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.highlight.keyword) {
            stateTl.add(new TweenLite(stateAnimation, 0.01, {pixi : {brightness : 1.7}}));
        }
        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.lowlight.keyword) {
            stateTl.add(new TweenLite(stateAnimation, 0.01, {pixi : {brightness : 0.6}}));
        }
        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.randomObslete.keyword) {
            stateTl.add(new TweenLite(stateAnimation, 0.01, {pixi : {brightness : 1}, alpha : 0.3}));
        }

        return stateTl;
    }

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        this._genericWinContainer.visible = (
            newState.state.keyword == DirtyWildsGameConfig.instance.SYMBOL_STATES.win.keyword ||
            newState.state.keyword == DirtyWildsGameConfig.instance.SYMBOL_STATES.individualWin.keyword
        );

        const stateTl:TimelineLite = this.getStateTl(newState.state.keyword, stateAnimation);

        timeline.add(stateTl, delay);
    }


    protected addOldStateAnimation(timeline:TimelineLite, transition:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addOldStateAnimation(timeline, transition, stateAnimation, delay);
    }
}